var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.182C0 .977.977 0 2.182 0h43.636C47.023 0 48 .977 48 2.182v29.09a2.182 2.182 0 01-2.182 2.183H2.182A2.182 2.182 0 010 31.273V2.182z",
    fill: "#0742A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.834 21.634H19.26l1.61-9.696h2.574l-1.61 9.696zM31.166 12.174a6.493 6.493 0 00-2.31-.413c-2.542 0-4.332 1.32-4.343 3.208-.02 1.393 1.282 2.166 2.256 2.63.996.475 1.335.785 1.335 1.207-.01.65-.805.95-1.546.95-1.028 0-1.578-.155-2.415-.516l-.34-.155-.36 2.176c.604.268 1.716.506 2.871.517 2.702 0 4.46-1.3 4.481-3.312.01-1.104-.678-1.95-2.16-2.64-.901-.444-1.453-.743-1.453-1.197.01-.413.467-.836 1.483-.836a4.475 4.475 0 011.918.372l.233.103.35-2.094zM35.774 11.938h1.991l2.077 9.696h-2.384s-.233-1.114-.307-1.454h-3.305l-.54 1.454h-2.701l3.823-8.891c.265-.63.732-.805 1.346-.805zm-.16 3.548s-.815 2.156-1.027 2.713h2.14c-.106-.485-.594-2.806-.594-2.806l-.18-.835a53.013 53.013 0 01-.338.928zM17.11 11.938l-2.521 6.612-.276-1.34c-.466-1.548-1.928-3.23-3.56-4.065l2.31 8.479h2.722l4.047-9.686H17.11z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.248 11.938H8.106l-.043.196c3.231.805 5.371 2.744 6.25 5.075l-.9-4.456c-.148-.619-.604-.794-1.165-.815z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7bba91116c0354d19d1d98239ebaf369.svg";
export { ForwardRef as ReactComponent };